<script setup lang="ts">
  const props = withDefaults(defineProps<{ size?: number; rating: number; padding?: number }>(), {
    size: 6,
    rating: 0,
    padding: 1,
  })
</script>

<template>
  <div class="flex flex-row">
    <span v-for="star in 5" :key="star" :class="star < 5 ? `pr-${padding}` : ''">
      <i-fa7-solid-star
        :class="`size-${size} ` + (star <= rating ? 'text-[#ffe57c]' : 'text-[#393126]')"
      />
    </span>
  </div>
</template>
